import type { Patient } from '@/types/session';
import type { BloodTestOrderPatient } from './bloodTests.types';

/** The page's selected patient in the shape the order sheet takes. */
export const toOrderPatient = (patient: Patient | null): BloodTestOrderPatient | undefined =>
  patient
    ? {
        ssn: patient.ssn,
        dbId: patient.dbId,
        name: patient.registryName ?? patient.name,
      }
    : undefined;

/**
 * The page's selected patient is tab-wide (restored from sessionStorage), so on
 * a resumed session it can belong to another patient than the todo. Lock the
 * order to it only when its transcriber_db id is the todo patient's id;
 * otherwise null, i.e. kennitala lookup mode.
 */
export const resolveOrderPatient = (
  selectedPatient: BloodTestOrderPatient | undefined,
  todoPatientDbId: number | null | undefined
): BloodTestOrderPatient | null =>
  selectedPatient?.dbId != null && selectedPatient.dbId === todoPatientDbId ? selectedPatient : null;
